import styled from "styled-components/macro";

export const RelativeContainer = styled.div`
  position: relative;
`;

export const ScenesMenuContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: row;
  border-radius: 10px;
  background: var(--primary-cta);
  color: white;
  user-select: none;

  &.disabled {
    opacity: 0.5;

    .disabled {
      opacity: 1;
    }
  }

  .text-button-wrapper,
  .icon-button-wrapper {
    display: flex;
    height: 38px;
    background-color: var(--transparent);
    transition: background-color 0.2s ease-in-out;
    padding: 2px;

    > div {
      border-radius: 0;
    }

    &:first-child {
      border-right: solid 1.5px rgba(255, 255, 255, 0.3);
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }

    &.icon-button-wrapper {
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
      width: auto;

      .icon-wrapper {
        height: auto;
        width: auto;
        padding: 11px 9px 10px;

        svg {
          width: 14px;
          height: 14px;

          path {
            fill: white;
          }
        }
      }
    }

    &:hover {
      background: var(--primary-cta-hover) !important;

      > div {
        background-color: transparent;
      }
    }

    .text-button-inner,
    .icon-wrapper {
      padding: 5px 7px;
      color: white;
      font-weight: 500;
      font-size: 14px;
      line-height: 1.6em;
      font-family: Inter, sans-serif;

      svg {
        path {
          fill: white;
        }
      }
    }
  }
`;

export const OptionsContainer = styled.div`
  position: absolute;
  top: 46px;
  right: 0;
  list-style: none;
  background-color: var(--menu-color);
  border-radius: 10px;
  z-index: 3000;
  overflow: hidden auto;
  transition: all 0.1s ease-out;
  scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);
  box-shadow: rgba(0, 0, 0, 0.15) 0 2px 6px;
  padding-left: 0;

  max-height: min(calc(-205px + 100vh), 555px);

  &.hidden {
    max-height: 0;
    opacity: 0;
  }

  header {
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    padding: 1rem 1.5rem;
    align-items: center;
    font-size: 0.9rem;
    border-bottom: 1px solid var(--menu-color-hover);

    p {
      line-height: 1.6em !important;
      color: var(--grey-0);
      font-weight: 500;
    }
  }

  ul {
    li.option-item {
      min-width: 18rem;
      button.option-item-button {
        color: var(--grey-0) !important;
        padding: 6px 15px !important;
        font-family: Inter, sans-serif !important;
        background-color: transparent !important;
        width: 100%;
        text-align: left;
        border-radius: 0 !important;
        margin: 0 !important;

        &:hover,
        &.selected {
          background-color: var(--menu-color-hover) !important;
        }
      }
    }
  }
`;

export const TextButtonLabel = styled.div`
  padding: 0 0.3rem;
  text-align: left;
  .text-button-small {
    font-size: 10px;
    line-height: 1em !important;
  }

  .text-button-label {
    line-height: 1em !important;
    padding-bottom: 3px;
  }
`;
